// Components==============
import trainingIndex from 'actions/training/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import FluidGrid from 'components/UI/FluidGrid';
import HeroLayout from 'components/UI/HeroLayout';
import InformationModal from 'components/UI/trainingModals/InformationModal';
import InterestModal from 'components/UI/trainingModals/InterestModal';
import SubscriptionModal from 'components/UI/trainingModals/SubscriptionModal';
import TrainingCard from 'components/UI/TrainingCard';
import useActiveModal from 'hooks/useActiveModal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './index.module.scss';
import Filter from './Filter';
// =========================

export default function Network() {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        dispatch(trainingIndex());
    }, []);

    const trainings = useSelector((state) =>
        state?.training?.entities?.allIds?.map(
            (id) => state?.training?.entities?.byId[id]
        ).filter((training) =>
            // Filter by wether by if training is network event
            !!training.is_network_event
        ).filter((training) =>
            searchValue.length
                ? training?.name
                      .toLowerCase()
                      .includes(searchValue.toLowerCase())
                : true
        )
    );

    const { activeModal, training_url } = useActiveModal(
        trainings,
    );

    return (
        <Layout>
            <Container>
                <HeroLayout>
                        <div
                            styleName={`wrapper`}
                        >
                        <Filter
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                        />
                        <FluidGrid
                            items={trainings}
                            component={<TrainingCard network/>}
                            isNetworkPage
                        />
                    </div>
                    <InformationModal
                        training_url={training_url}
                        training={activeModal}
                        basePath="netwerk"
                    />
                    <SubscriptionModal
                        training_url={training_url}
                        training={activeModal}
                        basePath="netwerk"
                    />
                    <InterestModal
                        training_url={training_url}
                        training={activeModal}
                        basePath="netwerk"
                    />
                </HeroLayout>
            </Container>
        </Layout>
    );
}
